import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { BankIdLogo } from '../../model/bankid-logo.model';

@Component({
    selector: 'ssf-logo-bankid',
    template: `<img [src]="logoURI" [alt]="'Logo'" class="ssf-logo" *ngIf="logoURI">`,
    styles: [`
        .ssf-logo {
            max-width: 100%;
            max-height: 100%;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoBankIdComponent implements OnInit, OnChanges {

    @Input() logo: BankIdLogo;
    public logoURI: SafeUrl;

    constructor(private sanitizer: DomSanitizer) {}

    ngOnInit(): void {
        this.createURI();
    }

    ngOnChanges(): void {
        this.createURI();
    }

    private createURI() {
        if (this.logo) {
            this.logoURI = this.sanitizer.bypassSecurityTrustUrl('data:;base64,' + this.logo.base64Logo);
        }
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/logo/logo-bankid.component.ts